// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/filestore/v1/filestore.proto" (package "c1.api.filestore.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefID
 */
export interface FileRefID {
    /**
     * @generated from protobuf field: string file_id = 1
     */
    fileId: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefDatasource
 */
export interface FileRefDatasource {
    /**
     * @generated from protobuf field: string datasource_id = 1
     */
    datasourceId: string;
    /**
     * @generated from protobuf field: string file_name = 2
     */
    fileName: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefObjectStore
 */
export interface FileRefObjectStore {
    /**
     * @generated from protobuf field: string object_store_id = 1
     */
    objectStoreId: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.File
 */
export interface File {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string type = 2
     */
    type: string;
    /**
     * @generated from protobuf field: int64 size = 3
     */
    size: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_modified = 4
     */
    lastModified?: Timestamp;
    /**
     * @generated from protobuf field: bytes file = 5
     */
    file: Uint8Array;
    /**
     * @generated from protobuf field: string file_id = 6
     */
    fileId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp uploaded_at = 7
     */
    uploadedAt?: Timestamp;
    /**
     * @generated from protobuf field: map<int32, string> hashes = 8
     */
    hashes: {
        [key: number]: string;
    };
    /**
     * @generated from protobuf oneof: file_ref
     */
    fileRef: {
        oneofKind: "id";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefID id = 100
         */
        id: FileRefID;
    } | {
        oneofKind: "datasource";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefDatasource datasource = 101
         */
        datasource: FileRefDatasource;
    } | {
        oneofKind: "objectStore";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefObjectStore object_store = 102
         */
        objectStore: FileRefObjectStore;
    } | {
        oneofKind: undefined;
    };
}
/**
 * It's important that enum has the same order as the one in the model layer so that the type integers
 * proto/c1/models/filestore/v1/filestore.proto
 *
 * @generated from protobuf enum c1.api.filestore.v1.HashType
 */
export enum HashType {
    /**
     * @generated from protobuf enum value: HASH_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: HASH_TYPE_MD5 = 1;
     */
    MD5 = 1,
    /**
     * @generated from protobuf enum value: HASH_TYPE_SHA256 = 2;
     */
    SHA256 = 2,
    /**
     * @generated from protobuf enum value: HASH_TYPE_ETAG = 3;
     */
    ETAG = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class FileRefID$Type extends MessageType<FileRefID> {
    constructor() {
        super("c1.api.filestore.v1.FileRefID", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FileRefID>): FileRefID {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileId = "";
        if (value !== undefined)
            reflectionMergePartial<FileRefID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileRefID): FileRefID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_id */ 1:
                    message.fileId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileRefID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_id = 1; */
        if (message.fileId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefID
 */
export const FileRefID = new FileRefID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileRefDatasource$Type extends MessageType<FileRefDatasource> {
    constructor() {
        super("c1.api.filestore.v1.FileRefDatasource", [
            { no: 1, name: "datasource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FileRefDatasource>): FileRefDatasource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.datasourceId = "";
        message.fileName = "";
        if (value !== undefined)
            reflectionMergePartial<FileRefDatasource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileRefDatasource): FileRefDatasource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string datasource_id */ 1:
                    message.datasourceId = reader.string();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileRefDatasource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string datasource_id = 1; */
        if (message.datasourceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.datasourceId);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefDatasource
 */
export const FileRefDatasource = new FileRefDatasource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileRefObjectStore$Type extends MessageType<FileRefObjectStore> {
    constructor() {
        super("c1.api.filestore.v1.FileRefObjectStore", [
            { no: 1, name: "object_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FileRefObjectStore>): FileRefObjectStore {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.objectStoreId = "";
        if (value !== undefined)
            reflectionMergePartial<FileRefObjectStore>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileRefObjectStore): FileRefObjectStore {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string object_store_id */ 1:
                    message.objectStoreId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileRefObjectStore, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string object_store_id = 1; */
        if (message.objectStoreId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.objectStoreId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefObjectStore
 */
export const FileRefObjectStore = new FileRefObjectStore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class File$Type extends MessageType<File> {
    constructor() {
        super("c1.api.filestore.v1.File", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "size", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "last_modified", kind: "message", T: () => Timestamp },
            { no: 5, name: "file", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "uploaded_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "hashes", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 100, name: "id", kind: "message", oneof: "fileRef", T: () => FileRefID },
            { no: 101, name: "datasource", kind: "message", oneof: "fileRef", T: () => FileRefDatasource },
            { no: 102, name: "object_store", kind: "message", oneof: "fileRef", T: () => FileRefObjectStore }
        ]);
    }
    create(value?: PartialMessage<File>): File {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = "";
        message.size = 0;
        message.file = new Uint8Array(0);
        message.fileId = "";
        message.hashes = {};
        message.fileRef = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<File>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: File): File {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* int64 size */ 3:
                    message.size = reader.int64().toNumber();
                    break;
                case /* google.protobuf.Timestamp last_modified */ 4:
                    message.lastModified = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastModified);
                    break;
                case /* bytes file */ 5:
                    message.file = reader.bytes();
                    break;
                case /* string file_id */ 6:
                    message.fileId = reader.string();
                    break;
                case /* google.protobuf.Timestamp uploaded_at */ 7:
                    message.uploadedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.uploadedAt);
                    break;
                case /* map<int32, string> hashes */ 8:
                    this.binaryReadMap8(message.hashes, reader, options);
                    break;
                case /* c1.api.filestore.v1.FileRefID id */ 100:
                    message.fileRef = {
                        oneofKind: "id",
                        id: FileRefID.internalBinaryRead(reader, reader.uint32(), options, (message.fileRef as any).id)
                    };
                    break;
                case /* c1.api.filestore.v1.FileRefDatasource datasource */ 101:
                    message.fileRef = {
                        oneofKind: "datasource",
                        datasource: FileRefDatasource.internalBinaryRead(reader, reader.uint32(), options, (message.fileRef as any).datasource)
                    };
                    break;
                case /* c1.api.filestore.v1.FileRefObjectStore object_store */ 102:
                    message.fileRef = {
                        oneofKind: "objectStore",
                        objectStore: FileRefObjectStore.internalBinaryRead(reader, reader.uint32(), options, (message.fileRef as any).objectStore)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap8(map: File["hashes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof File["hashes"] | undefined, val: File["hashes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.filestore.v1.File.hashes");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    internalBinaryWrite(message: File, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* int64 size = 3; */
        if (message.size !== 0)
            writer.tag(3, WireType.Varint).int64(message.size);
        /* google.protobuf.Timestamp last_modified = 4; */
        if (message.lastModified)
            Timestamp.internalBinaryWrite(message.lastModified, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bytes file = 5; */
        if (message.file.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.file);
        /* string file_id = 6; */
        if (message.fileId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.fileId);
        /* google.protobuf.Timestamp uploaded_at = 7; */
        if (message.uploadedAt)
            Timestamp.internalBinaryWrite(message.uploadedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, string> hashes = 8; */
        for (let k of globalThis.Object.keys(message.hashes))
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.hashes[k as any]).join();
        /* c1.api.filestore.v1.FileRefID id = 100; */
        if (message.fileRef.oneofKind === "id")
            FileRefID.internalBinaryWrite(message.fileRef.id, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.filestore.v1.FileRefDatasource datasource = 101; */
        if (message.fileRef.oneofKind === "datasource")
            FileRefDatasource.internalBinaryWrite(message.fileRef.datasource, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.filestore.v1.FileRefObjectStore object_store = 102; */
        if (message.fileRef.oneofKind === "objectStore")
            FileRefObjectStore.internalBinaryWrite(message.fileRef.objectStore, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.File
 */
export const File = new File$Type();
